import { type CacheBridgeFailureContext } from './cacheBridgeFailureReporter.ts';
import { reportCacheBridgeFailure } from './cacheBridgeDiagnostics.ts';

export type CacheBridgeCache = 'apollo' | 'relay';

export type CacheWriteResult =
	| { status: 'written' }
	| { status: 'skipped'; reason: string }
	| { status: 'failed'; error: unknown };

export function skipped(reason: string): CacheWriteResult {
	return { status: 'skipped', reason };
}

export function written(): CacheWriteResult {
	return { status: 'written' };
}

export function getSecondaryCache(source: CacheBridgeCache): CacheBridgeCache {
	return source === 'apollo' ? 'relay' : 'apollo';
}

export function getFailureContext(
	bridge: CacheBridgeFailureContext['bridge'],
	operation: CacheBridgeFailureContext['operation'],
	targetCache: CacheBridgeCache,
): CacheBridgeFailureContext {
	return { bridge, operation, targetCache };
}

function runSafely<TResult>(
	run: () => TResult,
	context: CacheBridgeFailureContext,
	onError: (error: unknown) => TResult,
): TResult {
	try {
		return run();
	} catch (error) {
		reportCacheBridgeFailure(error, context);
		return onError(error);
	}
}

export function writeSafely(
	write: () => CacheWriteResult,
	context: CacheBridgeFailureContext,
): CacheWriteResult {
	return runSafely(write, context, (error) => ({
		status: 'failed',
		error,
	}));
}
